import { useContext, useState } from "react";
import OrderService from "../../../service/OrderService";
import { useHistory, useLocation } from "react-router-dom";
import { CartContext } from "../../../contexts/CartContext/CartContext";
import { useToastContext } from "../../../contexts/ToastContext/ToastContext";

const useButtonAddToCart = ({
  productInfo,
  productQty,
  currentVariation,
  onErrorOneSeller,
  onErrorData,
  onErrorAddToCart,
  onErrorDownloadableAndNonDownloadable,
  onErrorItemAlreadyInCart,
}) => {
  const orderService = new OrderService();
  const Navigate = useHistory();
  const location = useLocation();
  const { showErrorToast } = useToastContext();

  const isFringeBenefitsPage = location?.pathname?.toLowerCase()?.includes("fringe");

  const orderKey = isFringeBenefitsPage
    ? "__extraconomy_order_fringe_benefit"
    : "__extraconomy_order";

  const cartUrl = isFringeBenefitsPage ? "/cart-fringe-benefit" : "/cart";

  const { addItemToCart } = useContext(CartContext);
  const [loadingOrder, setLoadingOrder] = useState(false);
  const [cartFull, setCartFull] = useState(false);

  const addItem = async (productSectionButton) => {
    try {
      const order = JSON.parse(localStorage.getItem(orderKey));
      const share = new URLSearchParams(location?.search)?.get("share")?.trim() || null;

      const res = await orderService.postAddItem(
        localStorage.getItem("__extraconomy_token"),
        localStorage.getItem("__extraconomy_username"),
        order.id,
        productInfo.data.product.id,
        productQty,
        0,
        currentVariation?.id ? currentVariation.id : null,
        share,
      );

      if (res.messageCode === 500067) onErrorOneSeller();
      else if (res.messageCode !== 200000) onErrorData(res.messageCode);
      else {
        const order = res.result;
        localStorage.setItem(orderKey, JSON.stringify(order));
        setLoadingOrder(false);

        if (!productSectionButton) {
          Navigate.push(cartUrl);
        }
      }
    } catch (e) {
      if (e.status === 401) {
        localStorage.removeItem("__extraconomy_token");
        localStorage.removeItem("__extraconomy_username");
        setLoadingOrder(false);
        Navigate.push("/login");
      }
      console.log(e);
    }
  };

  const addToCart = async (productSectionButton) => {
    try {
      setLoadingOrder(true);

      const share = new URLSearchParams(location?.search)?.get("share")?.trim() || null;

      if (!localStorage.getItem("__extraconomy_token")) {
        const guestOrder = localStorage.getItem(orderKey);
        const productData = productInfo.data;

        if (!guestOrder) {
          const newGuestOrder = {
            itens: [
              {
                product: productData.product,
                productVariation: currentVariation,
                quantity: productQty,
                priceUnitary:
                  currentVariation?.priceUnique ||
                  productData.product.promotionalPriceUnique ||
                  productData.product.priceUnique,
                totalItem:
                  (currentVariation?.priceUnique ||
                    productData.product.promotionalPriceUnique ||
                    productData.product.priceUnique) * productQty,
                percentualExtraCoin: 0,
                shareToken: share,
              },
            ],
            amountOrder:
              (currentVariation?.priceUnique ||
                productData.product.promotionalPriceUnique ||
                productData.product.priceUnique) * productQty,
            isGuestCart: true,
          };

          localStorage.setItem(orderKey, JSON.stringify(newGuestOrder));
          addItemToCart(productData);
          setLoadingOrder(false);

          if (!productSectionButton) {
            Navigate.push(cartUrl);
          }
        } else {
          const order = JSON.parse(guestOrder);

          if (order.isGuestCart) {
            const onlyOneSeller =
              order.itens[0].product.user.username !== productData.product.user.username;

            if (onlyOneSeller) {
              onErrorOneSeller();
              setLoadingOrder(false);
              return;
            }

            const sameShippingOption =
              order.itens[0].product.shippingOption === productData.product.shippingOption;

            if (!sameShippingOption) {
              showErrorToast({ detail: "differentShippingOption" });
              setLoadingOrder(false);
              return;
            }

            const cartHasDownloadableAndNotdownloadable =
              (order.itens[0].product.downloadable && !productData.product.downloadable) ||
              (!order.itens[0].product.downloadable && productData.product.downloadable);

            if (cartHasDownloadableAndNotdownloadable) {
              onErrorDownloadableAndNonDownloadable();
              setLoadingOrder(false);
              return;
            }

            const found = order.itens.find((item) => item.product.id === productData.product.id);

            if (found) {
              onErrorItemAlreadyInCart();
              setLoadingOrder(false);
              return;
            }

            const priceUnitary =
              currentVariation?.priceUnique ||
              productData.product.promotionalPriceUnique ||
              productData.product.priceUnique;

            order.itens.push({
              product: productData.product,
              productVariation: currentVariation,
              quantity: productQty,
              priceUnitary,
              totalItem: priceUnitary * productQty,
              percentualExtraCoin: 0,
              shareToken: share,
            });

            order.amountOrder = order.itens.reduce((sum, item) => sum + item.totalItem, 0);

            localStorage.setItem(orderKey, JSON.stringify(order));
            addItemToCart(productData);
            setLoadingOrder(false);

            if (!productSectionButton) {
              Navigate.push(cartUrl);
            }
          } else {
            showErrorToast({ detail: "pleaseLoginToContinue" });
            setLoadingOrder(false);
          }
        }
      } else {
        if (!localStorage.getItem(orderKey)) {
          let res;

          if (isFringeBenefitsPage) {
            res = await orderService.postCreateFringeBenefitOrder(
              productInfo.data.product.id,
              productQty,
            );
          } else {
            res = await orderService.postCreateOrder(
              localStorage.getItem("__extraconomy_token"),
              localStorage.getItem("__extraconomy_username"),
              productInfo.data.product.user.username,
              productInfo.data.product.id,
              productQty,
              0,
              currentVariation ? currentVariation.id : null,
              share,
            );
          }

          if (res.messageCode !== 200000) {
            if (res.messageCode === 500069) {
              const routeUrl = isFringeBenefitsPage ? "/fringe-benefit/" : "/product/";

              Navigate.push(`${routeUrl}${productInfo?.data?.product?.id}`);

              setLoadingOrder(false);
            } else {
              onErrorAddToCart(res.messageCode);
              setLoadingOrder(false);
            }
          } else {
            addItemToCart(productInfo?.data);

            const order = res.result;

            localStorage.setItem(orderKey, JSON.stringify(order));

            setLoadingOrder(false);
            setCartFull(true);

            if (!productSectionButton) {
              Navigate.push(cartUrl);
            }
          }
        } else {
          const order = JSON.parse(localStorage.getItem(orderKey));

          if (isFringeBenefitsPage) {
            if (
              order?.fringeBenefit?.user?.username ===
              localStorage.getItem("__extraconomy_username")
            ) {
              showErrorToast({ detail: "errorThisProductIsYours" });
              setLoadingOrder(false);
              return;
            }

            if (order?.fringeBenefit) {
              showErrorToast({ detail: "youCanPutOnlyOneItemInCart" });
              setLoadingOrder(false);
            }

            return;
          }

          const onlyOneSeller =
            order.itens[0].product.user.username !== productInfo.data.product.user.username;

          const sameShippingOption =
            order.itens[0].product.shippingOption === productInfo.data.product.shippingOption;

          const cartHasDownloadableAndNotdownloadable =
            (order.itens[0].product.downloadable && !productInfo.data.product.downloadable) ||
            (!order.itens[0].product.downloadable && productInfo.data.product.downloadable);

          if (cartHasDownloadableAndNotdownloadable) {
            onErrorDownloadableAndNonDownloadable();
            setLoadingOrder(false);
            return false;
          }

          const found = order.itens.find((item) => item.product.id === productInfo.data.product.id);

          if (
            !found &&
            !cartHasDownloadableAndNotdownloadable &&
            !onlyOneSeller &&
            sameShippingOption
          ) {
            addItemToCart(productInfo?.data);
          }

          if (!found) {
            addItem(productSectionButton).finally(() => {
              setLoadingOrder(false);
            });
          } else {
            onErrorItemAlreadyInCart();
            setLoadingOrder(false);
          }
        }
      }
    } catch (e) {
      setLoadingOrder(false);
      if (e.status === 401) {
        localStorage.removeItem("__extraconomy_token");
        localStorage.removeItem("__extraconomy_username");
        Navigate.push("/login");
      }
      console.log(e);
    }
  };

  return {
    addToCart,
    loadingOrder,
    cartFull,
  };
};

export default useButtonAddToCart;
